import { CheckoutType } from "config/common";
import { SubscriptionActions } from "component-library";

export function checkSubscriptionActionHasPermit(
  subscriptionActions: SubscriptionActions,
  type: CheckoutType
): boolean {
  switch (type) {
    case CheckoutType.Renewal:
      return subscriptionActions.isEligibleToRenew;
    case CheckoutType.Reactivation:
      return subscriptionActions.isEligibleToReactivate;
    case CheckoutType.Change:
      return subscriptionActions.isEligibleToChangePlan;
    case CheckoutType.Graduate:
      return subscriptionActions.isEligibleForGradTransfer;
    default:
      return false;
  }
}
